import Dashboard from "./Dashboard.jsx";

export default Dashboard;
